<template>
  <w-icon-wrapper icon-name='work-calculation-icon'>
    <g
      id='_17_Kalkulations-_Planungsfenster_Icon'
      data-name='17 Kalkulations-  /Planungsfenster_Icon'
      transform='translate(0 -0.048)'
    >
      <path
        id='Pfad_55672'
        d='M0,.048v24H24v-24Zm22,11H13v-9h9Zm-11-9v9H2v-9Zm-9,11h9v9H2Zm11,9v-9h9v9Z'
        data-name='Pfad 55672'
        fill='currentColor'
      />
      <path
        id='Pfad_55673'
        d='M9.125,5.75h-1.5V4.25a1,1,0,0,0-2,0v1.5h-1.5a1,1,0,0,0,0,2h1.5v1.5a1,1,0,0,0,2,0V7.75h1.5a1,1,0,0,0,0-2Z'
        data-name='Pfad 55673'
        fill='currentColor'
        transform='translate(-0.125 -0.25)'
      />
      <path
        id='Pfad_55674'
        d='M9.475,18.061,8.414,17l1.061-1.061a1,1,0,0,0-1.414-1.414L7,15.586,5.939,14.525a1,1,0,0,0-1.414,1.414L5.586,17,4.525,18.061a1,1,0,0,0,1.414,1.414L7,18.414l1.061,1.061a1,1,0,0,0,1.414-1.414Z'
        data-name='Pfad 55674'
        fill='currentColor'
        transform='translate(-0.5 0.548)'
      />
      <g
        id='Gruppe_25432'
        data-name='Gruppe 25432'
        transform='translate(0.5 0.048)'
      >
        <path
          id='Pfad_55675'
          d='M19.5,7.5h-5a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z'
          data-name='Pfad 55675'
          fill='currentColor'
        />
      </g>
      <g
        id='Gruppe_25433'
        data-name='Gruppe 25433'
        transform='translate(0 0.048)'
      >
        <path
          id='Pfad_55676'
          d='M20,17H15a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z'
          data-name='Pfad 55676'
          fill='currentColor'
        />
      </g>
      <g
        id='Gruppe_25434'
        data-name='Gruppe 25434'
        transform='translate(0 0.048)'
      >
        <path
          id='Pfad_55677'
          d='M20,20H15a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z'
          data-name='Pfad 55677'
          fill='currentColor'
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCalculation' };
</script>
